const scope_0 = require('/opt/build/repo/.cache/gatsby-mdx/mdx-scopes-dir/c1722893adb653d5589509fdb478a5a5.js').default;
const scope_1 = require('/opt/build/repo/.cache/gatsby-mdx/mdx-scopes-dir/e17e492970c242cef30cfe985ade36b8.js').default;
const scope_2 = require('/opt/build/repo/.cache/gatsby-mdx/mdx-scopes-dir/e43fb7ea8e5c973fc291302acf6043f3.js').default;export default 
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    